import styled from 'styled-components'

const Svg = styled.svg`
  transform: rotate(${props => (props.opened ? '180deg' : '0deg')});
`

const ChevronDown = ({ opened, color = '#717284' }) => {
  return (
    <Svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      opened={opened}
    >
      <path
        d='M4 6l4 4 4-4'
        stroke={color}
        fill='none'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Svg>
  )
}

export default ChevronDown
